/******/ (() => {
  // webpackBootstrap
  var __webpack_exports__ = {};
  window.PXUTheme.jsFeaturedCollection = {
    init: function ($section) {
      // Add settings from schema to current object
      window.PXUTheme.jsFeaturedCollection = $.extend(
        this,
        window.PXUTheme.getSectionData($section)
      );

      if (this.collection_layout == "slider") {
        this.createSlider($section, ".slider-gallery--desktop");
      }

      if (this.collection_layout_mobile == "slider") {
        this.createSlider($section, ".slider-gallery--mobile");
      }
    },
    revealSlider: function ($slider, $section) {
      if ($slider.hasClass("is-ready")) return;
      $slider.addClass("is-ready");
      $section
        .find(".featured-collection, .goa-red-featured-collection")
        .addClass("is-slider-ready");
      if ($slider.hasClass("flickity-enabled")) {
        $slider.flickity("resize");
      }
    },
    createSlider: function ($section, el) {
      const slider = $section.find(el);
      if (!slider.length) return;

      // The default "Featured collection" slider (sections/index__featured-collection.liquid)
      // should never loop infinitely; other sections sharing this JS keep the prior behavior.
      const isDefaultFeaturedCollection = $section.hasClass(
        "featured-collection-section"
      );

      let config = {
        lazyLoad: 2,
        freeScroll: true,
        imagesLoaded: true,
        draggable: true,
        cellAlign: "left",
        wrapAround: !isDefaultFeaturedCollection,
        pageDots: false,
        contain: !isDefaultFeaturedCollection,
        percentPosition: false,
        prevNextButtons: this.products_limit > this.products_per ? true : false,
        initialIndex: 0,
        arrowShape: arrowShape
      };

      if (isDefaultFeaturedCollection) {
        config.selectedAttraction = 0.004;
        config.friction = 0.2;
        config.freeScrollFriction = 0.03;
      }

      const calcluateArrowsPosition = () => {
        const sliders = $section[0].querySelectorAll(
          ".featured-collection--slider, .goa-red-featured-collection--slider"
        );
        sliders.forEach((sliderEl) => {
          const image = sliderEl.querySelector(
            ".image__container.product__imageContainer"
          );
          if (!image) {
            console.error("Image couldn't be found");
            return;
          }
          //fixking flickity button height to 44px, if needed this can be dynamical
          const halfImage = image.offsetHeight / 2;
          const arrows = sliderEl.querySelectorAll(".flickity-button");
          arrows.forEach((arrow) => {
            arrow.style.top = `${halfImage}px`;
          });
        });
      };

      if (matchMedia("screen and (max-width: 768px)").matches) {
        config.cellAlign = "left";
        config.wrapAround = false;
        if (!isDefaultFeaturedCollection) {
          config.contain = true;
        }
        config.arrowShape = {
          x0: 10,
          x1: 60,
          y1: 50,
          x2: 60,
          y2: 45,
          x3: 15,
        };
        calcluateArrowsPosition();
      }

      const self = this;
      slider.each(function () {
        const $slider = $(this);
        if ($slider.hasClass("flickity-enabled")) return;

        const reveal = function () {
          self.revealSlider($slider, $section);
        };

        $slider.one("ready.flickity", reveal);
        $slider.one("settle.flickity", reveal);
        if (!isDefaultFeaturedCollection) {
          $slider.on("settle.flickity", function () {
            $slider.flickity("resize");
          });
        }

        $slider.flickity(config);
        window.setTimeout(reveal, 4000);
      });
    },
    unload: function ($section) {
      let $slider = $section.find(".flickity-enabled");
      $slider.flickity("destroy");
    },
  };

  /******/
})();
